import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormField, form } from '@angular/forms/signals';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { AgreementService, Mail, Messenger } from '../service';

export interface ReservationData {
  id: string;
}

@Component({
  selector: 'lcm-reservation-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatProgressBarModule, MatInputModule, FormField],
  template: `
    <h2 mat-dialog-title>Do any reservations for this agreement need to be renewed?</h2>
    <mat-dialog-content>
      <div class="entity-form">
        <mat-form-field>
          <mat-label> Notes </mat-label>
          <textarea matInput [formField]="form.notes"></textarea>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton mat-dialog-close [disabled]="pending()">Cancel</button>
      <button matButton [disabled]="pending()" (click)="reserve()">Confirm</button>
    </mat-dialog-actions>

    @if (pending()) {
      <mat-progress-bar mode="indeterminate" />
    }
  `,
})
export class ReservationDialog {
  data = inject(MAT_DIALOG_DATA) as ReservationData;
  hostDialog = inject(MatDialogRef);
  messenger = inject(Messenger);
  mailer = inject(Mail);
  agreements = inject(AgreementService);

  pending = signal(false);

  model = signal({ notes: '' });
  form = form(this.model);

  reserve() {
    const item = this.agreements.agreements().find((it) => it.AgreementNumber === this.data.id);
    if (item) {
      const notes = this.form.notes().value();
      this.mailer.sendReservation(notes, item.AgreementNumber, item.Title);
    } else {
      this.messenger.error(`Agreement ${this.data.id} is not found`);
    }
    this.hostDialog.close(true);
  }
}
